import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Tooltip } from 'react-tooltip'; // Import Tooltip from react-tooltip
import { FiCopy } from "react-icons/fi";
import { FiX } from "react-icons/fi";

const Container = styled.div`
  padding: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
    color:#2B3497

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormItem = styled.div`
  flex: 1 1 300px; /* Flex-grow, flex-shrink, and minimum width */
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
   &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

// const Button = styled.button`
//   padding: 10px 20px;
//   border: none;
//   border-radius: 12px;
//   font-size: 16px;
//   color: #fff;
//   cursor: pointer;
//   box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
//   &:first-child {
//     background-color: #FF4B4B;
//     box-shadow: 0px 10px 20px #7E18182E;
//   }
//   &:last-child {
//     background-color: #2B3497;
//     box-shadow: 0px 10px 20px #2B349752;
//   }
// `;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;

`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;



const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const ConfigurationPage = () => {
  const [formValues, setFormValues] = useState({
    configurationName: '',
    configurationValue: '',
    configurationType: '',
  });
  const [formValuesUpdate, setFormValuesUpdate] = useState({
    configurationName: '',
    configurationValue: '',
    configurationType: '',
  });

  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get('/Configuration/GetConfigurationDetails');
        console.log(",response", response.data);

        setTableData(response.data);
      } catch (error) {
        console.error('Error fetching employee data:', error);
      }
    };

    fetchEmployeeData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSubmit = async () => {
    if (formValues.configurationName && formValues.configurationValue && formValues.configurationType) {
      setFormValues({
        configurationName: '',
        configurationValue: '',
        configurationType: '',
      });
      const loginUser = localStorage.getItem('loginUsername')
      const requestData = {
        txtConfigName: formValues.configurationName,
        txtConfigValue: formValues.configurationValue,
        txtConfigType: formValues.configurationType,
        txtCreatedBy: loginUser,
        dtCreatedOn: new Date().toISOString(),
        txtModifiedBy: "",
        dtModifiedOn: new Date().toISOString()
      }
      try {
        const response = await axios.post('/Configuration/AddConfiguration	', requestData);
        if (response.status == 200) {
          toast.success('Configuration added successfully');
          handleReset();
          try {
            const response = await axios.get('/Configuration/GetConfigurationDetails');
            console.log(",response", response.data);

            setTableData(response.data);
            setIsPopupVisibleCreate(false)
          } catch (error) {
            console.error('Error fetching employee data:', error);
          }
        }

      } catch (error) {

      }
    } else {
      toast.error("Please fill the all fields")
    }
  };

  const handleReset = () => {
    setFormValues({
      configurationName: '',
      configurationValue: '',
      configurationType: '',
    });
  };


  const filteredData = tableData.filter((row) =>
    row.txtConfigName && row.txtConfigName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.txtConfigValue && row.txtConfigValue.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.txtConfigType && row.txtConfigType.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
  setCurrentPage(1);
}, [searchQuery]);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState('');


  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  const handleEdit = (row) => {
    console.log("get row data", row);
    setPopupData(row.id)
    setFormValuesUpdate({
      configurationName: row.txtConfigName,
      configurationValue: row.txtConfigValue,
      configurationType: row.txtConfigType,
    })
    setPopupData(row);
    setIsPopupVisible(true);

  }
  const closePopup = () => {

    setIsPopupVisible(false);

  };
  const handleInputChangeUpdate = (e) => {
    const { name, value } = e.target;
    setFormValuesUpdate((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmitUpdate = async () => {
    if (formValuesUpdate.configurationName && formValuesUpdate.configurationValue && formValuesUpdate.configurationType) {
      setFormValuesUpdate({
        configurationName: '',
        configurationValue: '',
        configurationType: '',
      });
      const loginUser = localStorage.getItem('loginUsername')
      const requestData = {
        id: popupData.id,
        txtConfigName: formValuesUpdate.configurationName,
        txtConfigValue: formValuesUpdate.configurationValue,
        txtConfigType: formValuesUpdate.configurationType,
        txtCreatedBy: loginUser,
        dtCreatedOn: new Date().toISOString(),
        txtModifiedBy: loginUser,
        dtModifiedOn: new Date().toISOString()
      }
      try {
        const response = await axios.put('/Configuration/UpdateConfiguration	', requestData);

        if (response.status == 200) {
          toast.success('Configuration updated successfully');
          handleReset();

          try {
            const response = await axios.get('/Configuration/GetConfigurationDetails');
            console.log(",response", response.data);

            setTableData(response.data);
          } catch (error) {
            console.error('Error fetching employee data:', error);
          }
          setIsPopupVisible(false);
        }

      } catch (error) {

      }
    } else {
      toast.error("Please fill the all fields")
    }
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: <span style={{ color: '#dc3545' }}>Warning</span>,
      message: 'Are you sure you want to delete this Configuration?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              // Sending the PUT request to mark the visitor type as deleted
              await axios.delete(`/Configuration/DeleteConfiguration/${id}`);

              // Update the local state to remove the deleted visitor type from the UI
              setTableData((prevData) => prevData.filter(item => item.id !== id));

              // Show success toast message
              toast.success('Configuration Deleted Successfully');
            } catch (error) {
              console.error('Error deleting  Configuration:', error);
              // Show error toast message
              toast.error('Failed to Delete Configuration');
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            // Close the dialog without action
          }
        }
      ]
    });
  };

  const [copiedRowId, setCopiedRowId] = useState(null); // Track copied row ID

  const handleCopy = (text, rowId) => {
    navigator.clipboard.writeText(text);
    setCopiedRowId(rowId); // Set copied row ID
    setTimeout(() => setCopiedRowId(null), 2000); // Hide after 2 seconds
  };
  const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

  const handleAddLocationClick = () => {
    setIsPopupVisibleCreate(true);
  };
  return (
    <Container>
      <Header>
        <Heading>Configuration</Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </SearchBox>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Add Configuration <FiPlus size={20} />
          </Button>
        </div>
        {/* <FormGroup>
          <FormItem>
            <Label>
              Configuration Name<Asterisk>*</Asterisk>
            </Label>
            <Input
              type="text"
              name="configurationName"
              value={formValues.configurationName}
              onChange={handleInputChange}
              placeholder="Enter configuration name"
            />
          </FormItem>
          <FormItem>
            <Label>
              Configuration Value<Asterisk>*</Asterisk>
            </Label>
            <Input
              type="text"
              name="configurationValue"
              value={formValues.configurationValue}
              onChange={handleInputChange}
              placeholder="Enter configuration value"
            />
          </FormItem>
          <FormItem>
            <Label>
              Configuration Type<Asterisk>*</Asterisk>
            </Label>
            <Input
              type="text"
              name="configurationType"
              value={formValues.configurationType}
              onChange={handleInputChange}
              placeholder="Enter configuration type"
            />
          </FormItem>
        </FormGroup>
        <ButtonGroup>
          <Button onClick={handleReset}>Reset</Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </ButtonGroup> */}
      </Card>
      {filteredData.length === 0 ? (
        <ZeroStateMessage>No data available</ZeroStateMessage>
      ) : (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <TableHeader colSpan={'4'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Configuration Details</span>
                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </IconWrapper>
                  </div>
                </TableHeader>

              </tr>
            </thead>
            {isExpanded && (
              <>
                <thead>
                  <tr>
                    <TableHeader onClick={() => handleSort('txtConfigName')}>Config Name{sortColumn === 'txtConfigName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('txtConfigValue')}>Config Value {sortColumn === 'txtConfigValue' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('txtConfigType')}>Config Type{sortColumn === 'txtConfigType' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.txtConfigName}</TableCell>
                      <TableCell>
                        <Tooltip
                          id={`tooltip-${row.id}`} // Unique tooltip for each row
                          place="top"
                          className="custom-tooltip-new"
                          style={{
                            backgroundColor: "#293495",
                            color: "#fff",
                            fontSize: "12px",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            whiteSpace: "pre-line",
                            wordBreak: "break-word",
                            maxWidth: "800px",
                          }}
                        />

                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {/* Truncated Text */}
                          <span
                            data-tooltip-id={`tooltip-${row.id}`} // Unique tooltip ID
                            data-tooltip-content={row.txtConfigValue}
                            style={{
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "200px",
                            }}
                          >
                            {row.txtConfigValue && row.txtConfigValue.length > 80
                              ? `${row.txtConfigValue.substring(0, 80)}...`
                              : row.txtConfigValue || ""}
                          </span>

                          {/* Copy Button */}
                          <FiCopy
                            style={{ cursor: "pointer", color: "#293495" }}
                            onClick={() => handleCopy(row.txtConfigValue, row.id)}
                          />
                        </div>

                        {/* Copied Text Indicator (only for the copied row) */}
                        {copiedRowId === row.id && (
                          <span style={{ fontSize: "12px", color: "green", marginLeft: "8px" }}>
                            Copied!
                          </span>
                        )}
                      </TableCell>

                      <TableCell>{row.txtConfigType}</TableCell>
                      <TableCell>
                        <IconWrapper onClick={() => handleEdit(row)}>
                          <FiEdit />
                        </IconWrapper>
                        <IconWrapper onClick={() => handleDelete(row.id)}>
                          <FiTrash2 />
                        </IconWrapper>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </>)}
          </StyledTable>

          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>)}
          {isPopupVisibleCreate && (
            <Popup>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, color: '#293495' }}>Add Configuration</h3>
                <FiX
                  style={{ cursor: 'pointer' }}
                  size={20}
                  onClick={() => setIsPopupVisibleCreate(false)}
                />
              </div>
              <LabelValueContainer>
                <Label>Configuration Name:</Label>
                <Value> <Input
                  type="text"
                  name="configurationName"
                  value={formValues.configurationName}
                  onChange={handleInputChange}
                  placeholder="Enter configuration name"
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Configuration Value:</Label>
                <Value><Input
                  type="text"
                  name="configurationValue"
                  value={formValues.configurationValue}
                  onChange={handleInputChange}
                  placeholder="Enter configuration value"
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Configuration Type:</Label>
                <Value><Input
                  type="text"
                  name="configurationType"
                  value={formValues.configurationType}
                  onChange={handleInputChange}
                  placeholder="Enter configuration type"
                /></Value>
              </LabelValueContainer>

              <ButtonContainer>
                <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
                <PopupButton onClick={handleSubmit}>Submit</PopupButton>
              </ButtonContainer>
              {/* Show loader when loading */}
            </Popup>
          )}

          {isPopupVisible && (
            <Popup>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, color: '#293495' }}>Update Configuration</h3>
                <FiX
                  style={{ cursor: 'pointer' }}
                  size={20}
                  onClick={() => setIsPopupVisible(false)}
                />
              </div>
              <LabelValueContainer>
                <Label>Configuration Name:</Label>
                <Value><Input
                  type="text"
                  name="configurationName"
                  value={formValuesUpdate.configurationName}
                  onChange={handleInputChangeUpdate}
                  placeholder="Enter Configuration Name"
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Configuration Value:</Label>
                <Value><Input
                  type="text"
                  name="configurationValue"
                  value={formValuesUpdate.configurationValue}
                  onChange={handleInputChangeUpdate}
                  placeholder="Enter Configuration Value"
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Configuration Type:</Label>
                <Value><Input
                  type="text"
                  name="configurationType"
                  value={formValuesUpdate.configurationType}
                  onChange={handleInputChangeUpdate}
                  placeholder="Enter Configuration Type"
                /></Value>
              </LabelValueContainer>

              <ButtonContainer>
                <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                <PopupButton onClick={handleSubmitUpdate}>Update</PopupButton>
              </ButtonContainer>
              {/* Show loader when loading */}
            </Popup>
          )}
        </TableContainer>
      )}
      <ToastContainer />
    </Container>
  );
};

export default ConfigurationPage;
